import { computed } from 'vue';
import { LoadingStatuses } from '@/models/loading.interface';
import store from '@/store';

export default class CampaignManagementCode {
	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});
}
